import ConfirmationModal from '../../components/confirmation-modal';
import PluginAction from '../plugin-action';

/**
 * Action for checklist list view.
 *
 * @author Reinhard Führicht <rf@typoheads.at>
 */
export default class ListAction extends PluginAction {
    constructor(container: HTMLElement) {
        super(container);
        this.initializeModals();
        ListAction.emitter.emit('ready', this);

    }

    /**
     * Initializes all modals for confirming certain actions like deleting offers.
     */
    private initializeModals(): void {
        // Initialize modal to remove an offer
        const removeModal = document.querySelector<HTMLElement>('#removeChecklistModal');
        if (removeModal) {
            const removeConfirmation = new ConfirmationModal(removeModal);
            removeConfirmation.emitter.on('confirm', (link: HTMLElement) => {
                const href = link.getAttribute('href');
                if (href) {
                    window.location.href = href;
                }
            });

            this.container.querySelectorAll<HTMLElement>('[data-action="remove"]').forEach(link => {
                link.addEventListener('click', e => {
                    e.preventDefault();
                    removeConfirmation.value = link;
                    removeConfirmation.show();
                });
            });
        }
    }
}
